<div class="dialog-content flex-col w-100 justify-stretch items-stretch">
  <h2 mat-dialog-title>{{user.firstName}} {{user.lastName}}</h2>
  <mat-dialog-content>
    <div class="flex-col mt-2">
      <div>{{addressLine1}}</div>
      <div>{{addressLine2}}</div>
      <div class="mt-2">Email: {{user.email}}</div>
      <div>Phone: {{user.phoneNumber | phoneNumber }}</div>
      <div>Mobile: {{user.mobilePhoneNumber | phoneNumber }}</div>
    </div>
    @if (brokerInfo) {
      <div class="flex-col mt-2">
        <div><u>Represented by: {{brokerInfo.brokerageName}}</u></div>
        <div>Agent: {{brokerInfo.agentFullName}}</div>
        <div>Email: {{brokerInfo.agentEmail}}</div>
        <div>Phone: {{brokerInfo.agentPhoneNumber  | phoneNumber }}</div>
        <div>Mobile: {{brokerInfo.agentMobilePhoneNumber  | phoneNumber }}</div>
      </div>
    }
    @if (currentProxyAmount) {
      <button mat-flat-button class="w-100 mt-2 warn-button" color="warn" (click)="onRemoveProxyClick()">Remove Proxy of {{currentProxyAmount | currency : 'USD' : 'symbol' : '1.2-2'}}</button>
    }
    @if (userBids?.length) {
      <table mat-table [dataSource]="userBids" class="user-bids-table table-stack-sm w-100 mt-2">
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef >Bid</th>
          <td mat-cell *matCellDef="let auctionBid"> {{auctionBid.currentBid | currency : 'USD' : 'symbol' : '1.2-2'}} </td>
        </ng-container>
        <ng-container matColumnDef="time">
          <th mat-header-cell *matHeaderCellDef class="stack-last">Bid Time</th>
          <td mat-cell *matCellDef="let auctionBid" class="stack-last" data-label="Bid Time"> {{auctionBid.bidDateTime | date:'medium' }} </td>
        </ng-container>
        <ng-container matColumnDef="proxy" >
          <th mat-header-cell *matHeaderCellDef >Proxy</th>
          <td mat-cell *matCellDef="let auctionBid"><span class="flex-row items-center"><mat-icon class="primary-color">@if(auctionBid.historicProxyAction=='INC'){arrow_upward}@else if(auctionBid.historicProxyAction=='DEC'){arrow_downward}@else if(auctionBid.historicProxyAction=='EQU'){block}</mat-icon>{{auctionBid.historicProxyAmount | currency : 'USD' : 'symbol' : '1.2-2'}}</span></td>
        </ng-container>
        <ng-container matColumnDef="equalized" >
          <th mat-header-cell *matHeaderCellDef >Equalized</th>
          <td mat-cell *matCellDef="let auctionBid" matTooltipClass="tooltip-linebreak" [matTooltip]="auctionBid.equalizedReasonTooltip">{{auctionBid.equalizedIndicator}}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let bid; columns: displayedColumns;"></tr>
      </table>
    }
    @if(canUseNotes){
      <div class="mt-2" >
        <app-entity-notes [entity]="user" [readOnly]="true"></app-entity-notes>
      </div>
    }
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="flex-row justify-stretch items-center w-100 mt-3">
      <button mat-flat-button class="w-100" color="primary" (click)="onConfirmClick()" tabindex="1" >{{confirmButtonText}}</button>
    </div>
  </mat-dialog-actions>
</div>

